/* global Swiper */
// *******************************************************************************
// Career Slider
// *******************************************************************************

const careerSliderElements = document.querySelectorAll('[data-slider="career-advice-slider"]');

const careerSliderOptions = {
  slidesPerView: 1,
  spaceBetween: 40,
  speed: 300,
  watchOverflow: true,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  breakpoints: {
    640: {
      slidesPerView: 3,
    },
  },
};

careerSliderElements.forEach((el) => {
  const careerSliderParent = el.closest('.career-advice');

  const prevButton = careerSliderParent.querySelector('.swiper-button-prev');
  const nextButton = careerSliderParent.querySelector('.swiper-button-next');

  careerSliderOptions.navigation.prevEl = prevButton;
  careerSliderOptions.navigation.nextEl = nextButton;

  const careerSlider = new Swiper(el, careerSliderOptions);
});

const updateCardsAjax = (parentEle) => {
  let dataTags = '';
  const careerAdviceSliderInner = parentEle.querySelector('.career-advice__slider-inner');

  const activeTags = parentEle.querySelectorAll('.career-advice__tag.is-active');
  activeTags.forEach((tag) => {
    dataTags += `${tag.getAttribute('data-tag')}|`;
  });

  const ajaxData = new FormData();
  ajaxData.append('action', 'getCareerAdviceCards');
  ajaxData.append('dataTags', dataTags);
  ajaxData.append('lang', localData.lang);

  axios
    .post(localData.siteURL, ajaxData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then((response) => {
      if (response.status === 200) {
        careerAdviceSliderInner.innerHTML = '';
        careerAdviceSliderInner.innerHTML = response.data.data.postHtml;
      }
    })
    .catch((err) => {
      console.error(err);
    });
};

// **************************************************
// Career tags
// **************************************************
attachEvent('.career-advice__tag', 'click', (tag) => {
  const parentEle = tag.target.closest('.career-advice');
  tag.target.classList.toggle('is-active');
  updateCardsAjax(parentEle);
});
